import React from "react";

export default function WatchGenerate(props) {
    return <div/>;
}
